

































































































































































































































































































































































































































import { ReportImageQuality, 
  ReportSettings,
  ReportEmailAddress,
  ImageReportAfterDamageAssessment,
  ProjectDataExchangeOptions,
  TimeEntriesAsSeparateReport,
  MeasurementProtocolAsSeparateReport,
  ReportFooterText,
  ReportContentOrder,
  ReportProjectInfo,
  ReportInclusion,
  resolveDocumentInclusions,
  resolveTimeEntryInclusions,
  toLegacyDocumentsAsSeparateReport,
  toLegacyTimeEntriesAsSeparateReport,
  DOCUMENT_INCLUSION_OPTIONS,
  TIME_ENTRY_INCLUSION_OPTIONS,
  SEPARATE_TIME_ENTRY_REPORT_OPTIONS
} from "@/data/models/Settings";
import { updateReportSettings } from "@/data/repository/SettingsRepository"
import { loadClient, getAllDevicesManagementAccess } from "@/data/repository/ClientRepository";
import { Component, Watch } from "vue-property-decorator";
import PickerDialogComponent from "../common/PickerDialog.vue";
import MultiSelectionPickerComponent from "../common/MultiSelectionPicker.vue";
import ClickableTextFieldComponent from "@/components/common/ClickableTextField.vue";
import { validateEmailAddresses } from "@/utils/EmailUtils";
import { compareArraysIgnoreOrder } from "@/utils/Utils";
import { defineOwnReportSettingsClientAccess, manageAllDevicesClientAccess } from "@/permissions/ClientPermissions";
import { ReportSettingsModule } from "@/store/modules/ReportSettingsModule";
import { createDefaultReportSettings } from "@/data/models/Client";
import ConfirmationDialogComponent from "../common/ConfirmationDialog.vue";
import FirestoreImageComponent from "../common/FirestoreImage.vue";
import { DocumentsAsSeparateReport, ReportsList, SendReportsOption } from "@/data/models/Report";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import SettingsPageMixin from "@/components/settings/SettingsPageMixin";

@Component({
  components: {
    "firestore-image": FirestoreImageComponent,
    "clickable-text-field": ClickableTextFieldComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    picker: PickerDialogComponent,
    "multi-selection-picker": MultiSelectionPickerComponent,
  },
})
export default class ReportSettingsComponent extends SettingsPageMixin {
  isInitializing = true;

  reportEmailAddress = "";
  dryingReportEmailAddress = "";
  damageReportEmailAddress = "";
  leakDetectionReportEmailAddress = "";

  errorDryingReportEmailAddress: string[] = [];
  errorDamageReportEmailAddress: string[] = [];
  errorLeakDetectionReportEmailAddress: string[] = [];

  reportImageQuality = ReportImageQuality.NORMAL;
  reportImageQualityOptions = [
    // Disable low image qualtiy for now since this is not yet supported by the project app
    /* ReportImageQuality.LOW, */
    ReportImageQuality.NORMAL,
    ReportImageQuality.HIGH,
  ];

  sendOutgoingReportsAs = SendReportsOption.NO;
  
  saveOutgoingReports = true;
  sendReportAsJson: boolean | undefined = false;

  timeEntriesOnNewPage: boolean | undefined = true;
  companyAddressInTimeRecord = true;
  workTimeInTimeRecord = false;
  phaseInTimeRecord = true;

  numImagesPerRow = 3;
  numImagesPerRowOptions = [2, 3];

  showReportConfigInProject = true;
  imageForMeasurementPoints = true;
  contentOrder = ReportContentOrder.SKETCH_IMAGES_TEXT;
  contentOrderOptions = Object.values(ReportContentOrder);
  imageReportAfterDamageAssessment = ImageReportAfterDamageAssessment.NO;
  showDamagePatternInfoInLeakDetectionReport = false;

  imageReportAfterDamageAssessmentOptions = Object.values(ImageReportAfterDamageAssessment);
  sendOutgoingReportsAsOptions = Object.values(SendReportsOption);

  yesNoValues = [true, false];

  initialReportSettings: ReportSettings = createDefaultReportSettings();

  projectDataExchange = ProjectDataExchangeOptions.CSV;
  projectDataExchangeOptions = Object.values(ProjectDataExchangeOptions);

  includeGenericDeviceAssignmentsInReport = false;
  createCertificate = false;
  contactDataInExternalReports = false;

  measurementProtocolAsSeparateReport = MeasurementProtocolAsSeparateReport.NO;
  measurementProtocolAsSeparateReportOptions = Object.values(MeasurementProtocolAsSeparateReport);

  documentsInReports: ReportInclusion[] = [];
  timeEntriesInReports: ReportInclusion[] = [];
  documentInclusionOptions = DOCUMENT_INCLUSION_OPTIONS;
  timeEntryInclusionOptions = TIME_ENTRY_INCLUSION_OPTIONS;
  separateTimeEntryReportOptions = SEPARATE_TIME_ENTRY_REPORT_OPTIONS;

  reportFooterText = ReportFooterText.APP_VERSION;
  reportFooterTextOptions = Object.values(ReportFooterText);

  reportProjectInfo = ReportProjectInfo.PROJECT_NUMBER;
  reportProjectInfoOptions = Object.values(ReportProjectInfo);

  showTotalPageCount = false;

  @Watch("dryingReportEmailAddress")
  onDryingReportEmailAddressChanged() {
    this.resetErrors(0)
  }

  @Watch("damageReportEmailAddress")
  onDamageReportEmailAddressChanged() {
    this.resetErrors(1)
  }

  @Watch("leakDetectionReportEmailAddress")
  onLeakDetectionReportEmailAddressChanged() {
    this.resetErrors(2)
  }

  @Watch("reportSettings")
  onReportSettingsChanged() {
    if (this.reportSettings && !this.reportSettings.areDefaultReportSettings) {
      this.initializeParameters(this.reportSettings, this.reportEmailAddress);  
    }
  }

  get hasChanged() {
    return (
      this.saveOutgoingReports !== this.initialReportSettings.saveReport ||
      this.sendOutgoingReportsAs !== this.initialReportSettings.sendReportsAs ||
      this.damageReportEmailAddress !== this.initialReportSettings.reportEmailAddress.damageReportEmailAddress ||
      this.dryingReportEmailAddress !== this.initialReportSettings.reportEmailAddress.dryingReportEmailAddress ||
      this.leakDetectionReportEmailAddress !== this.initialReportSettings.reportEmailAddress.leakDetectionReportEmailAddress ||
      this.numImagesPerRow !== this.initialReportSettings.pdfReportConfig?.numImagesPerRow ||
      this.reportImageQuality !== this.initialReportSettings.pdfReportConfig?.imageQuality ||
      this.showReportConfigInProject !== this.initialReportSettings.pdfReportConfig?.showReportConfigInProject ||
      // imageForMeasurementPoints equals !reduceReportSize
      this.imageForMeasurementPoints === this.initialReportSettings.pdfReportConfig?.reduceReportSize ||
      this.imageReportAfterDamageAssessment !== this.initialReportSettings.pdfReportConfig?.imageReportAfterDamageAssessment ||
      this.contentOrder !== this.initialReportSettings.pdfReportConfig?.contentOrder ||
      this.showDamagePatternInfoInLeakDetectionReport !== this.initialReportSettings.pdfReportConfig?.showDamagePatternInfoInLeakDetectionReport ||
      this.sendReportAsJson !== this.initialReportSettings.sendReportAsJson ||
      this.timeEntriesOnNewPage !== this.initialReportSettings.timeEntriesOnNewPage ||
      this.companyAddressInTimeRecord !== this.initialReportSettings.companyAddressInTimeRecord ||
      this.workTimeInTimeRecord !== this.initialReportSettings.workTimeInTimeRecord ||
      this.phaseInTimeRecord !== this.initialReportSettings.phaseInTimeRecord ||
      this.projectDataExchange !== this.initialReportSettings.projectDataExchange ||
      this.includeGenericDeviceAssignmentsInReport !== this.initialReportSettings.includeGenericDeviceAssignmentsInReport ||
      this.createCertificate !== this.initialReportSettings.createCertificate ||
      this.contactDataInExternalReports !== this.initialReportSettings.contactDataInExternalReports ||
      this.measurementProtocolAsSeparateReport !== this.initialReportSettings.measurementProtocolAsSeparateReport ||
      !compareArraysIgnoreOrder(this.documentsInReports, this.initialReportSettings.documentsInReports ?? []) ||
      !compareArraysIgnoreOrder(this.timeEntriesInReports, this.initialReportSettings.timeEntriesInReports ?? []) ||
      this.reportFooterText !== this.initialReportSettings.reportFooterText ||
      this.reportProjectInfo !== this.initialReportSettings.reportProjectInfo ||
      this.showTotalPageCount !== this.initialReportSettings.showTotalPageCount
    );
  }

  get showGenericDeviceAssignmentsSetting() {
    return manageAllDevicesClientAccess();
  }

  get canEdit() {
    return defineOwnReportSettingsClientAccess();
  }

  get readonly() {
    return !this.isEditMode || !this.canEdit;
  }

  get reportSettings() {
    return ReportSettingsModule.reportSettings;
  }

  get showReportEmailAddressSection() {
    return this.sendOutgoingReportsAsEmail &&
      (
        this.showDryingReportEmailAddressField ||
        this.showDamageReportEmailAddressField ||
        this.showLeakDetectionReportEmailAddressField
      );
  }

  get showDryingReportEmailAddressField() {
    return !this.readonly || this.dryingReportEmailAddress !== "";
  }

  get showDamageReportEmailAddressField() {
    return !this.readonly || this.damageReportEmailAddress !== "";
  }

  get showLeakDetectionReportEmailAddressField() {
    return !this.readonly || this.leakDetectionReportEmailAddress !== "";
  }

  get sendOutgoingReportsAsEmail() {
    return this.sendOutgoingReportsAs === SendReportsOption.LOCAL_EMAIL ||
      this.sendOutgoingReportsAs === SendReportsOption.IRES_CLOUD
  }

  get formatReportImageQuality() {
    const qualityMapping = {
      [ReportImageQuality.LOW]: "Low",
      [ReportImageQuality.NORMAL]: "Normal",
      [ReportImageQuality.HIGH]: "High",
    };

    return (value: ReportImageQuality) => {
      const qualityString = qualityMapping[value] || "Normal"; // Fallback to "Normal" if value is not in the mapping
      return this.$t(`settings.report.images.imageQuality${qualityString}`).toString();
    };
  }

  get formatProjectDataExchangeOptions() {
    return (projectDataExchangeOptions: ProjectDataExchangeOptions) => {
      return this.getProjectDataExchangeOptionsName(projectDataExchangeOptions);
    };
  }

  get reportInclusionFormatter() {
    return (value: ReportInclusion) => {
      switch (value) {
        case ReportInclusion.EXTERNAL_REPORT:
          return this.$t("settings.report.individualReports.reportInclusionOptions.externalReport").toString();
        case ReportInclusion.SEPARATE_REPORT:
          return this.$t("settings.report.individualReports.reportInclusionOptions.separateReport").toString();
        case ReportInclusion.SEPARATE_REPORT_TOTAL:
          return this.$t("settings.report.individualReports.reportInclusionOptions.separateReportTotal").toString();
        case ReportInclusion.SEPARATE_REPORT_INDIVIDUAL:
          return this.$t("settings.report.individualReports.reportInclusionOptions.separateReportIndividual").toString();
        default:
          return this.$t("settings.report.individualReports.reportInclusionOptions.internalReport").toString();
      }
    };
  }

  get imageReportAfterDamageAssessmentFormatter() {
    return (imageReportAfterDamageAssessment: ImageReportAfterDamageAssessment) => {
      switch (imageReportAfterDamageAssessment) {
        case ImageReportAfterDamageAssessment.SELECTION_AS_EXTERNAL_REPORT:
          return this.$t("settings.report.images.imageReportAfterDamageAssessmentOptions.selectionAsExternalReport").toString();
        case ImageReportAfterDamageAssessment.SELECTION_AS_INTERNAL_REPORT:
          return this.$t("settings.report.images.imageReportAfterDamageAssessmentOptions.selectionAsInternalReport").toString();
        default:
          return this.$t("settings.report.images.imageReportAfterDamageAssessmentOptions.no").toString();
      }
    };
  }

  get contentOrderFormatter() {
    return (value: ReportContentOrder) => {
      switch (value) {
        case ReportContentOrder.SKETCH_TEXT_IMAGES:
          return this.$t("settings.report.images.contentOrderOptions.sketchTextImages").toString();
        case ReportContentOrder.TEXT_SKETCH_IMAGES:
          return this.$t("settings.report.images.contentOrderOptions.textSketchImages").toString();
        default:
          return this.$t("settings.report.images.contentOrderOptions.sketchImagesText").toString();
      }
    };
  }

  get sendReportsOptionsFormatter() {
    return (sendOutgoingReportsAs: SendReportsOption) => {
      switch (sendOutgoingReportsAs) {
        case SendReportsOption.LOCAL_EMAIL:
          return this.$t("settings.report.outgoingReports.sendOutgoingReportsAsOptions.localEmail").toString();
        case SendReportsOption.IRES_CLOUD:
          return this.$t("settings.report.outgoingReports.sendOutgoingReportsAsOptions.iresCloud").toString();
        default:
          return this.$t("common.no").toString();
      }
    };
  }

  get measurementProtocolAsSeparateReportFormatter() {
    return (value: MeasurementProtocolAsSeparateReport) => {
      switch (value) {
        case MeasurementProtocolAsSeparateReport.YES:
          return this.$t("settings.report.individualReports.measurementProtocolAsSeparateReportOptions.yes").toString();
        default:
          return this.$t("settings.report.individualReports.measurementProtocolAsSeparateReportOptions.no").toString();
      }
    };
  }

  get reportFooterTextFormatter() {
    return (value: ReportFooterText) => {
      switch (value) {
        case ReportFooterText.COMPANY:
          return this.$t("settings.report.footer.footerTextOptions.company").toString();
        case ReportFooterText.LOCATION:
          return this.$t("settings.report.footer.footerTextOptions.location").toString();
        default:
          return this.$t("settings.report.footer.footerTextOptions.appVersion").toString();
      }
    };
  }

  get reportProjectInfoFormatter() {
    return (value: ReportProjectInfo) => {
      switch (value) {
        case ReportProjectInfo.PROJECT_NUMBER:
          return this.$t("settings.report.footer.projectInfoOptions.projectId").toString();
        case ReportProjectInfo.COLLECTION_NUMBER:
          return this.$t("settings.report.footer.projectInfoOptions.collectionNumber").toString();
        case ReportProjectInfo.PROJECT_NUMBER_AND_COLLECTION_NUMBER:
          return this.$t("settings.report.footer.projectInfoOptions.projectIdAndCollectionNumber").toString();
        default:
          return "";
      }
    };
  }

  getProjectDataExchangeOptionsName(projectDataExchangeOptions: ProjectDataExchangeOptions) {
    switch (projectDataExchangeOptions) {
      case ProjectDataExchangeOptions.NO:
        return this.$t(`settings.report.projectDataExchange.options.no`).toString();   
      case ProjectDataExchangeOptions.JSON:
        return this.$t(`settings.report.projectDataExchange.options.json`).toString();
      
      default:
        return this.$t(`settings.report.projectDataExchange.options.csv`).toString();
    }
  }

  numImagesPerRowFormatter(value: number) {
    return value.toString();
  }

  formatYesNo(value: boolean) {
    return this.$t(`common.${value ? "yes" : "no"}`).toString();
  }

  initializeParameters(
    reportSettings: ReportSettings,
    reportEmailAddress: string,
  ) {
    this.saveOutgoingReports = reportSettings.saveReport;

    if (reportSettings.sendReportsAs) {
      this.sendOutgoingReportsAs = reportSettings.sendReportsAs;
    }
    else {
      this.sendOutgoingReportsAs = reportSettings.sendReportAsEmail
        ? SendReportsOption.LOCAL_EMAIL
        : SendReportsOption.NO;
    }
    
    this.sendReportAsJson = reportSettings.sendReportAsJson ?? false;

    if (reportSettings.reportEmailAddress) {
      this.dryingReportEmailAddress = reportSettings.reportEmailAddress.dryingReportEmailAddress ?? "";
      this.damageReportEmailAddress = reportSettings.reportEmailAddress.damageReportEmailAddress ?? "";
      this.leakDetectionReportEmailAddress = reportSettings.reportEmailAddress.leakDetectionReportEmailAddress ?? "";
    }
    else {
      this.dryingReportEmailAddress = reportEmailAddress;
      this.damageReportEmailAddress = reportEmailAddress;
      this.leakDetectionReportEmailAddress = reportEmailAddress;
    }
    
    const reportConfig = reportSettings.pdfReportConfig;

    if (reportConfig) {
      this.numImagesPerRow = reportConfig.numImagesPerRow;
      this.showReportConfigInProject = reportConfig.showReportConfigInProject;
      this.imageForMeasurementPoints = reportConfig.reduceReportSize !== undefined ? !reportConfig.reduceReportSize : true;
      this.imageReportAfterDamageAssessment = reportConfig.imageReportAfterDamageAssessment !== undefined ? reportConfig.imageReportAfterDamageAssessment : ImageReportAfterDamageAssessment.NO;
      this.showDamagePatternInfoInLeakDetectionReport = reportConfig.showDamagePatternInfoInLeakDetectionReport !== undefined ? reportConfig.showDamagePatternInfoInLeakDetectionReport : false;
      this.reportImageQuality = reportConfig.imageQuality;
      this.contentOrder = reportConfig.contentOrder ?? ReportContentOrder.SKETCH_IMAGES_TEXT;
    }

    if (reportSettings.projectDataExchange !== undefined) {
      this.projectDataExchange = reportSettings.projectDataExchange;
    }
    else {
      this.initialReportSettings.projectDataExchange = this.projectDataExchange;
    }

    this.includeGenericDeviceAssignmentsInReport = getAllDevicesManagementAccess()
      ? (reportSettings.includeGenericDeviceAssignmentsInReport ?? false)
      : false;

    // Read as stored rather than forced to false without device-management access, like the
    // setting above: the control is hidden in that case, so forcing it would clear the client's
    // choice on the next save of an unrelated field.
    this.createCertificate = reportSettings.createCertificate ?? false;

    this.contactDataInExternalReports = reportSettings.contactDataInExternalReports ?? false;

    this.timeEntriesOnNewPage = reportSettings.timeEntriesOnNewPage === false
      ? false
      : true;

    this.companyAddressInTimeRecord = reportSettings.companyAddressInTimeRecord === false
      ? false
      : true;

    this.workTimeInTimeRecord = reportSettings.workTimeInTimeRecord === true
      ? true
      : false;

    this.phaseInTimeRecord = reportSettings.phaseInTimeRecord === false
      ? false
      : true;

    // The legacy `reportsList` is the oldest form of these two settings; it is resolved into the
    // legacy per-setting enums first, and those are then resolved into the current selections.
    let documentsAsSeparateReport = DocumentsAsSeparateReport.NO;
    let timeEntriesAsSeparateReport = TimeEntriesAsSeparateReport.NO;

    if (reportSettings.reportsList) {
      documentsAsSeparateReport = reportSettings.reportsList === ReportsList.INDIVIDUAL_PDF_DOCUMENTS
        || reportSettings.reportsList === ReportsList.SEPARATE_PDF_AND_TIME_ENTRIES
        ? DocumentsAsSeparateReport.YES
        : DocumentsAsSeparateReport.NO;

      timeEntriesAsSeparateReport = reportSettings.reportsList === ReportsList.SEPARATE_PDF_AND_TIME_ENTRIES
        ? TimeEntriesAsSeparateReport.YES_INDIVIDUAL
        : TimeEntriesAsSeparateReport.NO;
    }

    if (reportSettings.documentsAsSeparateReport) {
      documentsAsSeparateReport = reportSettings.documentsAsSeparateReport;
    }

    if (reportSettings.timeEntriesAsSeparateReport) {
      timeEntriesAsSeparateReport = reportSettings.timeEntriesAsSeparateReport;
    }

    this.documentsInReports = resolveDocumentInclusions({
      documentsInReports: reportSettings.documentsInReports,
      documentsAsSeparateReport,
    });

    this.timeEntriesInReports = resolveTimeEntryInclusions({
      timeEntriesInReports: reportSettings.timeEntriesInReports,
      timeEntriesAsSeparateReport,
    });

    this.measurementProtocolAsSeparateReport = reportSettings.measurementProtocolAsSeparateReport ?? MeasurementProtocolAsSeparateReport.NO;
    this.reportFooterText = reportSettings.reportFooterText ?? ReportFooterText.APP_VERSION;
    this.reportProjectInfo = reportSettings.reportProjectInfo ?? ReportProjectInfo.PROJECT_NUMBER;
    this.showTotalPageCount = reportSettings.showTotalPageCount ?? false;

    this.initialReportSettings = {
      saveReport: this.saveOutgoingReports,
      sendReportsAs: this.sendOutgoingReportsAs,
      sendReportAsEmail: this.sendOutgoingReportsAsEmail,
      sendReportAsJson: this.sendReportAsJson,
      projectDataExchange: this.projectDataExchange,
      reportEmailAddress: {
        damageReportEmailAddress: this.damageReportEmailAddress,
        dryingReportEmailAddress: this.dryingReportEmailAddress,
        leakDetectionReportEmailAddress: this.leakDetectionReportEmailAddress,
      },
      pdfReportConfig: {
        numImagesPerRow: this.numImagesPerRow,
        showReportConfigInProject: this.showReportConfigInProject,
        reduceReportSize: !this.imageForMeasurementPoints,
        imageReportAfterDamageAssessment: this.imageReportAfterDamageAssessment,
        showDamagePatternInfoInLeakDetectionReport: this.showDamagePatternInfoInLeakDetectionReport,
        imageQuality: this.reportImageQuality,
        contentOrder: this.contentOrder,
      },
      timeEntriesOnNewPage: this.timeEntriesOnNewPage,
      companyAddressInTimeRecord: this.companyAddressInTimeRecord,
      workTimeInTimeRecord: this.workTimeInTimeRecord,
      phaseInTimeRecord: this.phaseInTimeRecord,
      includeGenericDeviceAssignmentsInReport: this.includeGenericDeviceAssignmentsInReport,
      createCertificate: this.createCertificate,
      contactDataInExternalReports: this.contactDataInExternalReports,
      documentsAsSeparateReport: toLegacyDocumentsAsSeparateReport(this.documentsInReports),
      timeEntriesAsSeparateReport: toLegacyTimeEntriesAsSeparateReport(this.timeEntriesInReports),
      documentsInReports: this.documentsInReports,
      timeEntriesInReports: this.timeEntriesInReports,
      measurementProtocolAsSeparateReport: this.measurementProtocolAsSeparateReport,
      reportFooterText: this.reportFooterText,
      reportProjectInfo: this.reportProjectInfo,
      showTotalPageCount: this.showTotalPageCount
    }

    this.isEditMode = false;
  }

  async created() {
    this.isInitializing = true;
    const client = await loadClient();
    const reportSettings = this.reportSettings;

    if (!client) {
      return;
    }

    /** 
     * `reportEmailAddress` is deprecated. When it is set and `dryingReportEmailAddress`, 
     * `damageReportEmailAddress`, and `leakDetectionReportEmailAddress` are unset, its value 
     * is copied to these three variables for backward compatibility.
     */
    const reportEmailAddressDeprecated = client.reportEmailAddress ?? "";
    this.reportEmailAddress = reportEmailAddressDeprecated;

    if (reportSettings && !reportSettings.areDefaultReportSettings) {
      this.initializeParameters(reportSettings, reportEmailAddressDeprecated);
    }
    else {
      const reportEmailAddresses: ReportEmailAddress = {
        dryingReportEmailAddress: client.dryingReportEmailAddress ?? reportEmailAddressDeprecated,
        damageReportEmailAddress: client.damageReportEmailAddress ?? reportEmailAddressDeprecated,
        leakDetectionReportEmailAddress: client.leakDetectionReportEmailAddress ?? reportEmailAddressDeprecated,
      };

      this.initializeParameters({
          saveReport: true,
          sendReportAsEmail: false,
          sendReportAsJson: false,

          reportEmailAddress: reportEmailAddresses,
          pdfReportConfig: client.pdfReportConfig
        },
        reportEmailAddressDeprecated,
      )
    }
    this.isInitializing = false;
  }

  resetErrors(fieldId: number) {
    if (this.errorDryingReportEmailAddress.length !== 0 && fieldId === 0) {
      this.errorDryingReportEmailAddress = [];
    }
    if (this.errorDamageReportEmailAddress.length !== 0 && fieldId === 1) {
      this.errorDamageReportEmailAddress = [];
    }
    if (this.errorLeakDetectionReportEmailAddress.length !== 0 && fieldId === 2) {
      this.errorLeakDetectionReportEmailAddress = [];
    }
  }

  async doSave() {
    let isValid = true;

    if (this.sendOutgoingReportsAsEmail) {
      if (!validateEmailAddresses(this.dryingReportEmailAddress)) {
        isValid = false;
        this.errorDryingReportEmailAddress.push(this.$t("settings.report.errorEmailAddress").toString());
      }

      if (!validateEmailAddresses(this.damageReportEmailAddress)) {
        isValid = false;
        this.errorDamageReportEmailAddress.push(this.$t("settings.report.errorEmailAddress").toString());
      }

      if (!validateEmailAddresses(this.leakDetectionReportEmailAddress)) {
        isValid = false;
        this.errorLeakDetectionReportEmailAddress.push(this.$t("settings.report.errorEmailAddress").toString());
      }
    }

    if (!isValid) {
      SnackbarModule.showError({ key: "common.changesNotSaved" });
      throw new Error("validation");
    }

    const update: ReportSettings = {
      saveReport: this.saveOutgoingReports,
      /**
       * @deprecated
       * `sendReportAsEmail` is deprecated and should not be used. Please see `UserSettings`.
       */
      sendReportAsEmail: this.sendOutgoingReportsAsEmail,
      sendReportsAs: this.sendOutgoingReportsAs,
      sendReportAsJson: this.sendReportAsJson,

      reportEmailAddress: {
        dryingReportEmailAddress: this.dryingReportEmailAddress === "" ? null : this.dryingReportEmailAddress,
        damageReportEmailAddress: this.damageReportEmailAddress === "" ? null : this.damageReportEmailAddress,
        leakDetectionReportEmailAddress: this.leakDetectionReportEmailAddress === "" ? null : this.leakDetectionReportEmailAddress
      },

      pdfReportConfig: {
        numImagesPerRow: this.numImagesPerRow,
        imageQuality: this.reportImageQuality,
        showReportConfigInProject: this.showReportConfigInProject,
        reduceReportSize: !this.imageForMeasurementPoints,
        imageReportAfterDamageAssessment: this.imageReportAfterDamageAssessment,
        showDamagePatternInfoInLeakDetectionReport: this.showDamagePatternInfoInLeakDetectionReport,
        contentOrder: this.contentOrder,
      },

      timeEntriesOnNewPage: this.timeEntriesOnNewPage,
      companyAddressInTimeRecord: this.companyAddressInTimeRecord,
      workTimeInTimeRecord: this.workTimeInTimeRecord,
      phaseInTimeRecord: this.phaseInTimeRecord,
      projectDataExchange: this.projectDataExchange,
      includeGenericDeviceAssignmentsInReport: this.includeGenericDeviceAssignmentsInReport,
      createCertificate: this.createCertificate,
      contactDataInExternalReports: this.contactDataInExternalReports,
      // The two legacy enums are still written so that IRES Project builds which only read them
      // keep behaving as before; the arrays below are the current source of truth.
      documentsAsSeparateReport: toLegacyDocumentsAsSeparateReport(this.documentsInReports),
      timeEntriesAsSeparateReport: toLegacyTimeEntriesAsSeparateReport(this.timeEntriesInReports),
      documentsInReports: this.documentsInReports,
      timeEntriesInReports: this.timeEntriesInReports,
      measurementProtocolAsSeparateReport: this.measurementProtocolAsSeparateReport,
      reportFooterText: this.reportFooterText,
      reportProjectInfo: this.reportProjectInfo,
      showTotalPageCount: this.showTotalPageCount
    }

    await updateReportSettings(update);
    this.initialReportSettings = update;
  }

  mounted() {
    this.setToolbarTitle(this.$t("settings.report.reportSettings").toString());
  }
}
